import { isStringArray, useLocalStorage } from "@sfc/ui";
import { useCallback } from "react";

const BASE_KEY = "visitedNavItems";

const EMPTY_VISITED: string[] = [];

export function useVisitedNavItems(roundId: string | null) {
  const storageKey = roundId
    ? `${BASE_KEY}:${roundId}`
    : `${BASE_KEY}:__none__`;
  const [visited, setVisited] = useLocalStorage<string[]>(
    storageKey,
    EMPTY_VISITED,
    { validate: isStringArray },
  );

  const markVisited = useCallback(
    (key: string) => {
      if (!roundId) return;
      // The shared hook re-reads storage when applying functional updates, so
      // guide + badge instances cannot overwrite keys another instance wrote.
      setVisited((current) =>
        current.includes(key) ? current : [...current, key],
      );
    },
    [roundId, setVisited],
  );

  const isVisited = useCallback(
    (key: string) => (roundId ? visited.includes(key) : true),
    [roundId, visited],
  );

  return { visited, markVisited, isVisited };
}
